<app-loader></app-loader>
<p-toaster></p-toaster>

    <div class="resetpassword-outer">
        <div class="change-password">
            <div class="top-headings">
                <div class="reset-text">
                    <h4>Invite Driver</h4>
                </div>
                <div class="close-icon">
                    <img (click)="closeModal()" src="assets/images/export-close.svg" alt="Close"/>
                </div>
            </div>
        </div>

        <div class="email-inputouter">
            <form [formGroup]="inviteDriverForm">
            <label for="emailInput">Email/Mobile number <span class="custom-star">*</span></label>

            <input id="emailInput" type="text" formControlName="email" pInputText placeholder="Enter Email or Mobile Number" [maxlength]="50" (keydown)="preventFirstSpace($event)" (keydown.enter)="sendInviteToDriver()"/>

            <div
                *ngIf="inviteDriverForm.get('email')?.hasError('required')  && (inviteDriverForm.get('email')?.dirty || inviteDriverForm.get('email')?.touched)">
                <div class="validation-error"> This field is required*</div>
            </div>
            <div
                *ngIf="inviteDriverForm.get('email')?.hasError('invalidEmail') && (inviteDriverForm.get('email')?.dirty || inviteDriverForm.get('email')?.touched)">
                <div class="validation-error"> Please enter a valid email*</div>
            </div>
            <div
                *ngIf="inviteDriverForm.get('email')?.hasError('invalidPhone') && (inviteDriverForm.get('email')?.dirty || inviteDriverForm.get('email')?.touched)">
                <div class="validation-error"> Please enter a valid Mobile number*</div>
            </div>
        </form>
        </div>
        <div class="save-btn">
            <p-button label="Send" (onClick)="sendInviteToDriver()"></p-button>
        </div>

    </div>
